import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullLoaderWithMsgComponent } from './full-loader-with-msg.component';
import { DirectivesModule } from '../directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    FullLoaderWithMsgComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FullLoaderWithMsgComponent,
    DirectivesModule,
    TranslationModule
  ]
})
export class FullLoaderWithMsgModule { }
